export interface BuiltinMap {
  id: string;
  name: string;
  cols: number;
  rows: number;
  tiles: string[][];
}

export const BUILTIN_MAPS: BuiltinMap[] = [
  {
    id: 'around-the-wall',
    name: 'Around the Wall',
    cols: 15,
    rows: 7,
    tiles: [
      ['normal','normal','normal','normal','hazard1','normal','normal','normal','normal','normal','hazard2','normal','normal','normal','normal'],
      ['normal','normal','normal','normal','normal','free','normal','normal','normal','normal','normal','normal','normal','normal','normal'],
      ['normal','normal','start','normal','normal','normal','normal','hazard1','wall','wall','wall','normal','normal','hazard2','normal'],
      ['normal','normal','normal','free','normal','normal','normal','wall','wall','end','normal','normal','normal','normal','normal'],
      ['normal','normal','normal','normal','normal','hazard1','normal','wall','wall','normal','normal','free','normal','normal','normal'],
      ['normal','normal','normal','normal','normal','normal','normal','normal','normal','normal','normal','hazard2','normal','normal','normal'],
      ['normal','normal','normal','normal','normal','hazard2','normal','normal','normal','hazard1','normal','normal','normal','normal','normal'],
    ],
  },
];
